export const bankAccountReportColumn = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "Número",
    accessor: "accountNumber",
  },
  {
    Header: "Nome da conta",
    accessor: "accountName",
  },
  {
    Header: "Moeda",
    accessor: "accountCurrency",
  },
  {
    Header: "Banco",
    accessor: "bankName",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
  {
    id: "report",
    Header: "Relatórios",
    accessor: "report",
  }
];
export const commonReportColumn = [
  {
    Header: "Nome",
    accessor: "name",
  },
  {
    id: "action",
    Header: "Ações",
    accessor: "action",
  },
];

export const columnsDataBankAccountReport = [

  {
    Header: "DIA",
    accessor: "dia",
  },
  {
    Header: "Nº DOC",
    accessor: "seqNumber",
  },
  {
    Header: "BENEFICIÁRIO",
    accessor: "beneficiaryName",
  },
  {
    Header: "DESCRIÇÃO",
    accessor: "description",
  },
  {
    Header: "DÉBITO",
    accessor: "debit",
  },
  {
    Header: "CRÉDITO",
    accessor: "credit",
  },
  {
    Header: "KWANZAS",
    accessor: "kwanza",
  },
  {
    Header: "SALDO DA CONTA",
    accessor: "balance",
  },
  {
    Header: "DATA",
    accessor: "registrationDateString",
  },
];

export const columnsDataCashAccountReport = [
  {
    Header: "DIA",
    accessor: "incomeDia",
  },
  {
    Header: "Nº DOC",
    accessor: "incomeNDoc",
  },
  {
    Header: "DESCRIÇÃO",
    accessor: "incomeDescription",
    Footer: "Total", 

  },
  {
    Header: "MOEDA",
    accessor: "incomeEuro",
  },
  {
    Header: "KWANZAS",
    accessor: "incomeKwanza",
  },

  {
    Header: "DIA",
    accessor: "expenseDia",
  },
  {
    Header: "Nº DOC",
    accessor: "expenseNDoc",
  },
  {
    Header: "DESCRIÇÃO",
    accessor: "expenseDescription",
    Footer: "Total", 

  },
  {
    Header: "MOEDA",
    accessor: "expenseEuro",
  },
  {
    Header: "KWANZAS",
    accessor: "expenseKwanza",
  },
];
